import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught render error:", error, info?.componentStack);

    // After a deploy, a tab left open from before still points at the old
    // JS chunk filenames (they're content-hashed and the old ones get
    // deleted on the next build) — lazy() then throws a chunk-load error
    // instead of a real bug. A single automatic reload picks up the fresh
    // index.html/chunks and silently fixes it, so the user never sees this
    // screen for what is really just a stale cache. Guarded by sessionStorage
    // so a genuinely broken chunk doesn't reload-loop forever.
    const isChunkError = /loading chunk|failed to fetch dynamically imported module|importing a module script failed/i.test(error?.message || "");
    if (isChunkError && !sessionStorage.getItem("chunkErrorReloaded")) {
      sessionStorage.setItem("chunkErrorReloaded", "1");
      window.location.reload();
    }
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", gap: 16, padding: 24, textAlign: "center",
        background: "#f4f7f5", fontFamily: "'DM Sans',-apple-system,sans-serif",
      }}>
        <div style={{ fontSize: 40 }}>⚠️</div>
        <h1 style={{ fontSize: 20, fontWeight: 800, color: "#1a3d2e", margin: 0 }}>Something went wrong</h1>
        <p style={{ fontSize: 14, color: "#666", margin: 0, maxWidth: 380 }}>
          This part of the page hit an unexpected error. Reloading usually fixes it.
        </p>
        <button onClick={this.handleReload} style={{
          padding: "11px 22px", background: "#32614d", color: "white", border: "none",
          borderRadius: 9, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
        }}>
          Back to home
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
